import {useState} from 'react'
import {Content} from '../../../../_metronic/layout/components/content'
import {KTIcon} from '../../../../_metronic/helpers'
import LinkForm from './modal/LinkForm'
import LinkList from './LinkList'
import {ILink} from './_modal'
import InputSearchBox from '../../../utils/components/form/InputSearchBox'

const Link = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedLink, setSelectedLink] = useState<ILink | undefined>(undefined)

  const onSelectLink = (link: ILink) => {
    setSelectedLink(link)
  }

  const onResetSelect = () => setSelectedLink(undefined)

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center mb-3 gap-4 flex-wrap'>
        <InputSearchBox
          placeholder='Search'
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />

        <div>
          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
            onClick={onResetSelect}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Add Link
          </button>
        </div>
      </div>

      <LinkList searchTerm={searchTerm} onSelectLink={onSelectLink} />

      <LinkForm selectedLink={selectedLink} onResetSelect={onResetSelect} />
    </Content>
  )
}

export default Link
